<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h6>Aulas de Reposição Agendadas</h6>
        <i class="bi bi-x-circle close-icon" @click="emit('fechar')" title="Fechar" />
      </div>
      <div class="table-container">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th>Aluno</th>
              <th>Turma</th>
              <th>Agendamento</th>
              <th class="text-center" style="width: 80px;">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!aulas.length">
              <td colspan="4" class="text-center">
                Nenhuma aula de reposição agendada.
              </td>
            </tr>
            <tr v-for="item in aulas" :key="item.id">
              <td>{{ item.aluno_nome }}</td>
              <td>{{ item.turma_completa }}</td>
              <td>{{ formatDate(item.data_aula) }}</td>
              <td class="text-center">

                <!-- Reagendar -->
                <button v-if="hasPermission('reagendar_aulas_reposicao')" class="btn btn-link p-0 action-btn"
                        @click="onReagendar(item)"
                        title="Reagendar aula">
                  <i class="bi bi-calendar-event text-info mx-1 cursor-pointer"></i>
                </button>

                <!-- Detalhar -->
                <!-- <button
                  class="btn btn-link p-0 action-btn ms-2"
                  @click="emit('detalhar', item.id)"
                  title="Detalhar"
                >
                  <i class="bi bi-arrow-right-circle  action-icon"></i>
                </button> -->

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, toRefs } from 'vue'

const props = defineProps({
  mostrar: { type: Boolean, default: true },
  aulas:   { type: Array,   default: () => [] }
})
const { mostrar, aulas } = toRefs(props)
const emit = defineEmits(['fechar', 'detalhar', 'reagendar'])

function onReagendar(item) {
  emit('reagendar', item)
}

function formatDate(d) {
  if (!d) return '—'
  // Aceita 'YYYY-MM-DD' ou ISO com 'T'
  if (typeof d === 'string' && d.includes('T')) {
    const dt = new Date(d)
    return isNaN(dt) ? d : dt.toLocaleDateString('pt-BR')
  }
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
    const [year, month, day] = d.split('-').map(Number)
    const date = new Date(year, month - 1, day)
    return isNaN(date) ? d : date.toLocaleDateString('pt-BR')
  }
  // Date ou outro formato
  const date = d instanceof Date ? d : new Date(d)
  return isNaN(date) ? String(d) : date.toLocaleDateString('pt-BR')
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 4px;
  z-index: 2001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f1f1f1;
  border-bottom: 1px solid #ddd;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.table-container {
  padding: 15px;
}

.table th,
.table td {
  vertical-align: middle;
}

.action-icon {
  cursor: pointer;
  font-size: 1.2rem;
  color: #007bff;
}

.action-icon:hover {
  color: #0056b3;
}
</style>
